import React from 'react';
import ReactDOM from 'react-dom';
import getapiclient from './lib/ajaxhelper'
import Tracker from './components/Tracker'
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';

/**
 * 
 * @param {React.Component} Componente - uno dei componenti React che devo esportare dal file lib/reactapp/index.js del plugin
 * @param {*} props - props del componente
 * @param {Element} dest - elemento del dom in cui farò il rendering del componente
 * @param {import('@material-ui/core').Theme} theme
 * @returns 
 */
const render = (Componente, props, dest, theme = null) => {

    const child = React.createElement(
        Componente, 
        props
    );

    return ReactDOM.render(
        theme !== null && theme !== undefined ? 
            React.createElement(
                MuiThemeProvider, 
                {theme: createMuiTheme(theme)}, 
                [child]                
            ) : 
            child,
        dest
    );
}

export {
    getapiclient,
    render,
    Tracker,
}
